import { render } from "./Qoute.vue?vue&type=template&id=b9529d8a"
import script from "./Qoute.vue?vue&type=script&lang=js"
export * from "./Qoute.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__